<app-widget-card-wrapper title="Whenua – Groundwater Ammoniacal Nitrogen" class="whenua">
  <h5 class="card-title-medium" style="color: #428644">Ammoniacal Nitrogen</h5>
  <div class="card-stretch">
    <h2><span>Click each bore to turn data on and off.</span></h2>
    <div echarts [options]="groundwaterNitrogenOption"></div>
    <!-- <h2 [ngStyle]="{ opacity: 0 }"><span>Filter by location:</span></h2>
    <select [ngStyle]="{ opacity: 0 }"></select> -->
  </div>
</app-widget-card-wrapper>
